module.exports = __webpack_public_path__ + "img/2381089-83-2.f3562cb1.png";